module.exports = __webpack_public_path__ + "static/media/user-white-small.0babd352.svg";